import { useState } from "react";
import { Button } from "expano-components";
import { Modal, Select } from "components";
const AssignUserModal = ({
  workers,
  product_group_name,
  handleClose,
  handleAssign,
}) => {
  const [user_id, setUserId] = useState(null);

  return (
    <Modal
      header={{ title: "Przypisz pracownika" }}
      handleClose={handleClose}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            disabled={!user_id}
            text="Przypisz"
            onClick={() => handleAssign(user_id)}
          />
        </>
      }
    >
      <div className="m-b-20">
        <p>
          <strong>{product_group_name}</strong>
        </p>
      </div>
      <Select
        label="Pracownik"
        handleChange={(value) => setUserId(value)}
        options={workers.map(({ id, full_name }) => ({
          label: full_name,
          value: id,
        }))}
      />
    </Modal>
  );
};

export default AssignUserModal;
